// Modelo para la categoría de unidad de medida
export interface UnitOfMeasureCategory {
  id: number;
  name: string;
}

// Para crear categoría (sin id requerido)
export type UnitOfMeasureCategoryCreate = Omit<UnitOfMeasureCategory, 'id'>;

// Para actualizar categoría (id obligatorio, resto opcional)
export type UnitOfMeasureCategoryUpdate = Partial<
  Omit<UnitOfMeasureCategory, 'id'>
> & { id: number };

// Modelo principal para unidades de medida
export interface UnitOfMeasure {
  id: number;
  name: string;
  factor: number;
  isActive: boolean;
  unitOfMeasureCategoryId: number;
  unitOfMeasureCategory?: UnitOfMeasureCategory;
}

// Para crear (sin id requerido, categoría opcional)
export type UnitOfMeasureCreate = Omit<
  UnitOfMeasure,
  'id' | 'unitOfMeasureCategory'
>;

// Para actualizar (id obligatorio, resto opcional)
export type UnitOfMeasureUpdate = Partial<
  Omit<UnitOfMeasure, 'id' | 'unitOfMeasureCategory'>
> & { id: number };

// Tipo de UnitOfMeasure (catálogo)
export interface UnitOfMeasureType {
  id: number;
  name: string;
  isActive: boolean;
}
